import $ from 'jquery';

(function () {


	function debounce(func) {
		var timer;
		return function (event) {
			if (timer) {
				clearTimeout(timer);
			}
			timer = setTimeout(func, 100, event);
		};
	}

	if (!seats.chat_enabled) {
		return;
	}

	window.addEventListener('resize', debounce(function (e) {
		change_chat_position();
	}));

	change_chat_position();

	function change_chat_position() {
		var waitForZopim = setInterval(function () {
			if (window.$zopim === undefined || window.$zopim.livechat === undefined) {
				return;
			}
			$zopim(function () {
				var blueBarHeight = $('.cta-collection-block').outerHeight();

				if ($(window).width() < 1400) {
					$zopim.livechat.button.setOffsetVertical(blueBarHeight);
					$zopim.livechat.button.setOffsetVerticalMobile(blueBarHeight);
				}
				else {
					$zopim.livechat.button.setOffsetVertical(0);
					$zopim.livechat.button.setOffsetVerticalMobile(0);
				}
			});
			clearInterval(waitForZopim);
		}, 100);
	}

})();